import './MainPageSub05_0.scss';
import MainPageSub05_1 from './MainPageSub05_1';
import MainPageSub05_2 from './MainPageSub05_2';
import React from 'react';
import 'aos/dist/aos.css';

const MainPageSub05_0 = () => {
    return (
        <div className="MainPageSub05_0">
            <section className='sec-main'>

                <p className="heading-1 title1">
                    05 <span className="i-custom">입시를 긋다</span>
                </p>
        
                <section className='sec-sub05'>

                    {/* 오른쪽에서 등장 */}
                    <div className='box-sub02' data-aos="fade-down" data-aos-delay="300">
                        <MainPageSub05_2 />  
                    </div>

                    {/* 왼쪽에서 등장 */}
                    <div className='box-sub01' data-aos="zoom-in" data-aos-delay="300">
                        <MainPageSub05_1 />  
                    </div>

                </section>

            </section>
        </div>
    );
};

export default MainPageSub05_0;
